import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import Loader from '@quicktools/shared-components/components/core/Loader';

import { AppProvider } from '../services/context/AppContext';
import analytics from '../services/analytics';

import Home from './Home';

const Editor = dynamic(() => import('./Editor'), { loading: () => <Loader /> });

function App() {
  const [showEditorPage, setShowEditorPage] = useState(false);

  useEffect(() => {
    analytics.landingPage();
  }, []);

  return (
    <AppProvider>
      {showEditorPage ? (
        <Editor setShowEditorPage={setShowEditorPage} />
      ) : (
        <Home setShowEditorPage={setShowEditorPage} />
      )}
    </AppProvider>
  );
}

export default App;
